import { jsx as _jsx } from "react/jsx-runtime";
import { classes } from "./classes.js";
import { Icon } from "./icon.js";
export const BUTTON_VARIANTS = ["primary", "secondary", "ghost"];
export function Button({ variant, block = false, type = "button", children, ...rest }) {
    return (_jsx("button", { type: type, className: classes("btn", `btn-${variant}`, block && "btn-block"), ...rest, children: children }));
}
export function IconButton({ glyph, label, size = "md", type = "button", ...rest }) {
    return (_jsx("button", { type: type, className: classes("btn", "btn-icon"), "aria-label": label, ...rest, children: _jsx(Icon, { glyph: glyph, size: size }) }));
}
//# sourceMappingURL=button.js.map